import React, { useState, useEffect } from "react";
import AdminSideMenu from "../../navbar/AdminSideMenu";
import AdminTopMenu from "../../navbar/AdminTopMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faChevronDown,
  faChevronUp,
  faChevronRight,
  faSort,
  faPaperPlane,
  faCheckCircle,
  faTimesCircle,
  faClock,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";
import { URL } from "../../common/Url";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { userid, token, type } from "../../common/AdminAuth";
import useSelectedDate from "../../../store/UseFilterDateStore";
import { getMasterCountryList, getUserPriceList } from "../../../api/api";

const num = (v) => parseInt(v || 0);
const totalsOf = (c) => {
  const d = num(c.delivered);
  const f = num(c.failed);
  const o = num(c.other);
  return { d, f, o, t: d + f + o };
};
const fmt = (n) => Number(n).toLocaleString();
const fmtCost = (n) =>
  Number(n).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
  });
// whole percent, but a non-zero value under 1% keeps one decimal
const pct = (n, t) => {
  if (t <= 0) return 0;
  const v = (n / t) * 100;
  return n > 0 && v < 1
    ? Math.max(0.1, Math.round(v * 10) / 10)
    : Math.round(v);
};

const VendorReport = () => {
  const [error, seterror] = useState({
    errarStatus: false,
    errorMessage: "",
    bgcolor: "",
  });

  var date = new Date();
  var todatdate =
    date.getFullYear() +
    "-" +
    (date.getMonth() + 1) +
    "-" +
    ("0" + date.getDate()).slice(-2);

  const setStoreDateFrom = useSelectedDate((state) => state.setStoreDateFrom);
  const setStoreDateTo = useSelectedDate((state) => state.setDateTo);
  const selctedDateFrom = useSelectedDate((state) => state.selctedDateFrom);
  const selctedDateTo = useSelectedDate((state) => state.selctedDateTo);

  const [DateFrom, setDateFrom] = useState(selctedDateFrom);
  const [DateTo, setDateTo] = useState(selctedDateTo);
  const [showDateFrom, setshowDateFrom] = useState(new Date());
  const [showDateTo, setshowDateTo] = useState(new Date());
  const [userList, setuserList] = useState([]);
  const [selectUser, setselectUser] = useState("");
  const [isloading, setisloading] = useState(false);
  const [searched, setSearched] = useState(false);
  const [openRows, setOpenRows] = useState({});
  const [openUser, setOpenUser] = useState("");
  const [companyList, setcompanyList] = useState([]);
  const [vendors, setVendors] = useState([]);

  useEffect(() => {
    getUserDetails();
    getMasterCountryList().then((res) => {
      setcompanyList(res.data.success === true ? res.data.data : []);
    });
  }, []);

  // Price entry (with its smsc_id) a user is routed through for a country code.
  // The price list `regex` looks like "^([\+]?61)".
  const findPrice = (prices, countryCode) => {
    if (!prices || prices.length === 0) return null;
    const code = String(parseInt(countryCode));
    const matches = prices.filter((p) => {
      const m = String(p.regex || "").match(/(\d+)/);
      return m && m[1] === code;
    });
    if (matches.length === 0) return null;
    const country = companyList.find(
      (c) => parseInt(c.country_code) === parseInt(countryCode)
    );
    return (
      matches.find(
        (p) => country && p.country_name === country.country_name
      ) || matches[0]
    );
  };

  // route_summary groups by vendor (smsc) -> date -> country code, and lists
  // the users that sent through that route. Customer cost needs each user's
  // price list; vendor cost comes from the route's buy_price.
  const buildVendors = (data, pricesByUser) => {
    return Object.keys(data)
      .map((name) => {
        const v = {
          name,
          d: 0,
          f: 0,
          o: 0,
          t: 0,
          customer: 0,
          vendor: 0,
          profit: 0,
          matched: false,
          rows: [],
          countries: {},
          users: {},
        };
        Object.keys(data[name] || {}).forEach((reportDate) =>
          Object.keys(data[name][reportDate]).forEach((countryCode) => {
            const node = data[name][reportDate][countryCode] || {};
            const buy = Number(node.buy_price) || 0;
            const users =
              node.users && Object.keys(node.users).length > 0
                ? node.users
                : { "-": node };
            Object.keys(users).forEach((u) => {
              const c = users[u] || {};
              const s = totalsOf({
                delivered: c.delivered,
                failed: c.failed,
                other: c.dlr_awaited,
              });
              const price =
                u === "-" ? null : findPrice(pricesByUser[u], countryCode);
              const vendorCost = buy * s.t;
              const customer = price ? price.cost * s.t : null;

              v.d += s.d;
              v.f += s.f;
              v.o += s.o;
              v.t += s.t;
              v.vendor += vendorCost;
              if (customer !== null) {
                v.customer += customer;
                v.profit += customer - vendorCost;
                v.matched = true;
              }
              v.countries[countryCode] = true;
              v.users[u] = true;
              v.rows.push({
                date: reportDate,
                countryCode,
                user: u,
                ...s,
                vendorCost,
                customer,
              });
            });
          })
        );
        // latest date first, then country, then user
        v.rows.sort((a, b) =>
          a.date !== b.date
            ? a.date < b.date
              ? 1
              : -1
            : a.countryCode !== b.countryCode
            ? Number(a.countryCode) - Number(b.countryCode)
            : a.user < b.user
            ? -1
            : 1
        );
        // per-user totals; each user keeps its own country rows
        v.userRows = Object.keys(v.users)
          .map((u) => {
            const rows = v.rows.filter((r) => r.user === u);
            return rows.reduce(
              (a, r) => ({
                ...a,
                d: a.d + r.d,
                f: a.f + r.f,
                o: a.o + r.o,
                t: a.t + r.t,
                vendorCost: a.vendorCost + r.vendorCost,
              }),
              { user: u, rows, d: 0, f: 0, o: 0, t: 0, vendorCost: 0 }
            );
          })
          .sort((a, b) => b.t - a.t);
        return v;
      })
      .sort((a, b) => b.t - a.t);
  };

  const summaryReport = () => {
    seterror({ errarStatus: false });
    setisloading(true);
    setSearched(true);
    setVendors([]);
    setOpenRows({});
    fetch(
      `${URL}report.php?user_id=${userid}&method=route_summary&date_from=${DateFrom}&date_to=${DateTo}&token=${token}&user_type=${type}`
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success !== true) {
          setisloading(false);
          seterror({
            errarStatus: true,
            errorMessage: result.message,
            bgcolor: "alert alert-danger",
          });
          return;
        }
        const all = result.data || {};
        // the chosen route is matched on the vendor (smsc) name
        const data = selectUser
          ? Object.keys(all)
              .filter((n) => n === selectUser)
              .reduce((o, n) => ({ ...o, [n]: all[n] }), {})
          : all;
        // every distinct user that appears under any vendor / date / country
        const userSet = {};
        Object.keys(data).forEach((vn) =>
          Object.keys(data[vn]).forEach((dt) =>
            Object.keys(data[vn][dt]).forEach((cc) =>
              Object.keys((data[vn][dt][cc] || {}).users || {}).forEach(
                (u) => (userSet[u] = true)
              )
            )
          )
        );
        return Promise.all(
          Object.keys(userSet).map((u) =>
            getUserPriceList(u)
              .then((res) => [u, res.data.success === true ? res.data.data : []])
              .catch(() => [u, []])
          )
        ).then((entries) => {
          const pricesByUser = {};
          entries.forEach(([u, list]) => (pricesByUser[u] = list));
          setVendors(buildVendors(data, pricesByUser));
          setisloading(false);
        });
      })
      .catch(() => {
        setisloading(false);
        seterror({
          errarStatus: true,
          errorMessage: "Unable to load the report",
          bgcolor: "alert alert-danger",
        });
      });
  };

  const handleDateFrom = (date) => {
    let dated =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      ("0" + date.getDate()).slice(-2);
    setDateFrom(dated);
    setStoreDateFrom(dated);
    setshowDateFrom(date);
  };

  const handleDateTo = (date) => {
    let dated =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      ("0" + date.getDate()).slice(-2);
    setDateTo(dated);
    setStoreDateTo(dated);
    setshowDateTo(date);
  };

  const getUserDetails = () => {
    fetch(
      `${URL}route.php?user_id=${userid}&method=retrieve_all&token=${token}&user_type=${type}`
    ).then((response) => {
      response.json().then((result) => {
        if (result.success === true) {
          setuserList(result.data);
        } else {
          seterror({
            errarStatus: true,
            errorMessage: result.message,
            bgcolor: "alert alert-danger",
          });
        }
      });
    });
  };

  const toggleRow = (name) => {
    // only one accordion open at a time
    setOpenRows(openRows[name] ? {} : { [name]: true });
    setOpenUser("");
  };

  const toggleUser = (key) => setOpenUser(openUser === key ? "" : key);

  const countryNameOf = (code) => {
    const c = companyList.find(
      (x) => parseInt(x.country_code) === parseInt(code)
    );
    return c ? c.country_name : "-";
  };

  const grand = vendors.reduce(
    (a, v) => ({
      d: a.d + v.d,
      f: a.f + v.f,
      o: a.o + v.o,
      t: a.t + v.t,
      customer: a.customer + v.customer,
      vendor: a.vendor + v.vendor,
      profit: a.profit + v.profit,
    }),
    { d: 0, f: 0, o: 0, t: 0, customer: 0, vendor: 0, profit: 0 }
  );


  return (
    <div className="layout-wrapper layout-content-navbar">
      <style>{`
        .sr-empty{padding:48px 16px;text-align:center;color:#6b7280}
        .sr-panel{border-radius:14px;border:0;box-shadow:0 2px 10px rgba(15,23,42,.06)}
        .sr-panel-head{padding:24px 28px 16px}
        .sr-panel-body{padding:0 28px 24px}
        .sr-h1{font-size:1.5rem;font-weight:700;color:#0f1f3d;margin:0}
        .sr-h1-sub{color:#4b5b76;font-size:.9rem;margin:4px 0 0}
        .sr-main{width:100%;border-collapse:separate;border-spacing:0}
        .sr-main thead th{background:#f3f4f7;color:#3d4b66;font-size:.72rem;letter-spacing:.05em;text-transform:uppercase;font-weight:600;padding:14px 12px;border:0;white-space:nowrap}
        .sr-main thead th:first-child{border-radius:8px 0 0 8px}
        .sr-main thead th:last-child{border-radius:0 8px 8px 0}
        .sr-main tbody td{padding:16px 12px;vertical-align:middle;border:0;border-bottom:1px solid #eceef2;color:#0f1f3d;font-size:.92rem}
        .sr-main-row{cursor:pointer}
        .sr-main-row:hover td{background:#fafbfc}
        .sr-chev{color:#1f2d4a;font-size:.8rem}
        .sr-uname{font-size:1.02rem;font-weight:500;color:#0f1f3d}
        .sr-strong{font-weight:600}
        .sr-stat{font-size:.95rem;margin-bottom:6px}
        .sr-stat b{font-size:1.1rem;font-weight:700}
        .sr-stat span{font-size:.85rem;opacity:.85}
        .sr-green{color:#1b7a43}
        .sr-red{color:#d1242f}
        .sr-amber{color:#e8920c}
        .sr-open-cell{border-bottom:0!important;background:transparent!important}
        .sr-break{background:#eef4fd;border:1px solid #d9e5f7;border-radius:10px;padding:18px 18px 18px;margin:8px 0 10px}
        .sr-globe{font-size:1.5rem;color:#2d4a7a;margin-left:6px}
        .sr-break-title{font-weight:700;color:#0f1f3d;font-size:1rem}
        .sr-break-sub{color:#4b5b76;font-size:.8rem}
        .sr-count-pill{background:#e8ecf3;color:#0f1f3d;border-radius:999px;padding:6px 14px;font-size:.78rem;font-weight:600}
        .sr-sub-title{font-weight:700;color:#0f1f3d;font-size:.95rem;margin-bottom:10px}
        .sr-user-row{cursor:pointer}
        .sr-user-row:hover td{background:#f6f3fd}
        .sr-user-open td{background:#f6f3fd}
        .sr-nest{background:#f6f3fd;border:1px solid #e3dbf5;border-radius:10px;padding:14px 16px;margin:4px 0 8px}
        .sr-inner-wrap{background:#fff;border:1px solid #d9e5f7;border-radius:10px;overflow:auto}
        .sr-inner{width:100%;border-collapse:collapse}
        .sr-inner thead th{background:#f7f8fa;color:#3d4b66;font-size:.72rem;letter-spacing:.04em;text-transform:uppercase;font-weight:600;padding:14px 10px;border:0;white-space:nowrap}
        .sr-inner tbody td{padding:12px 10px;vertical-align:middle;border:0;border-top:1px solid #f0f1f4;font-size:.85rem;color:#0f1f3d;white-space:nowrap}
      `}</style>
      <div className="layout-container">
        <AdminSideMenu />

        <div className="layout-page">
          <AdminTopMenu />

          <div className="content-wrapper">
            <div className="container-xxl container-p-y">
              <div className="card mb-4">
                <h5 className="card-header">Filter Options</h5>
                <div className="card-body">
                  <div className="row gy-3 align-items-end">
                    <div className="col-md-3 col-6">
                      <label>From Date</label>
                      <div className="input-group">
                        <button
                          className="btn btn-outline-primary d-none d-sm-block"
                          type="button"
                        >
                          From
                        </button>
                        <DatePicker
                          className="form-control btn-block"
                          dateFormat="MM/dd/yyyy"
                          selected={showDateFrom}
                          onChange={handleDateFrom}
                          placeholderText={todatdate}
                        />
                      </div>
                    </div>
                    <div className="col-md-3 col-6">
                      <label>To Date</label>
                      <div className="input-group">
                        <button
                          className="btn btn-outline-primary d-none d-sm-block"
                          type="button"
                        >
                          To
                        </button>
                        <DatePicker
                          className="form-control btn-block"
                          dateFormat="MM/dd/yyyy"
                          selected={showDateTo}
                          onChange={handleDateTo}
                          placeholderText={todatdate}
                        />
                      </div>
                    </div>
                    <div className="col-md-4 col-12">
                      <label>Select Route</label>
                      <select
                        value={selectUser}
                        onChange={(e) => setselectUser(e.target.value)}
                        name="route"
                        className="form-select"
                      >
                        <option value="">All routes</option>
                        {userList.map((items, i) => (
                          <option key={i} value={items.username}>
                            {items.username}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-2 col-12">
                      <button
                        onClick={summaryReport}
                        disabled={isloading}
                        className="btn btn-primary w-100"
                        type="button"
                      >
                        {isloading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Loading
                          </>
                        ) : (
                          <>
                            <FontAwesomeIcon icon={faSearch} className="me-2" />
                            Search
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {error.errarStatus ? (
                <div className={error.bgcolor} role="alert">
                  <strong>Alert!</strong> {error.errorMessage}
                </div>
              ) : null}

              {vendors.length > 0 && (
                  <div className="row mb-4">
                    {[
                      { label: "Total Sent", value: fmt(grand.t), cls: "text-secondary" },
                      { label: "Delivered", value: fmt(grand.d), cls: "text-success" },
                      { label: "Failed", value: fmt(grand.f), cls: "text-danger" },
                    ].map((k) => (
                      <div className="col-md-4 col-12 mb-3 mb-md-0" key={k.label}>
                        <div className="card">
                          <div className="card-body">
                            <span className="fw-semibold d-block mb-1">{k.label}</span>
                            <h3 className={"card-title mb-0 " + k.cls}>{k.value}</h3>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
              )}

              <div className="card sr-panel">
                <div className="d-flex justify-content-between align-items-start flex-wrap gap-3 sr-panel-head">
                  <div>
                    <h4 className="sr-h1">Vendor Report</h4>
                    <p className="sr-h1-sub">
                      View vendor wise message statistics and detailed country
                      breakdown.
                    </p>
                  </div>
                </div>

                <div className="table-responsive text-nowrap sr-panel-body">
                  {isloading ? (
                    <div className="sr-empty">Loading vendor report...</div>
                  ) : vendors.length === 0 ? (
                    <div className="sr-empty">
                      {searched
                        ? "No records found for the selected range."
                        : "Choose a date range and account, then press Search."}
                    </div>
                  ) : (
                    <table className="sr-main">
                      <thead>
                        <tr>
                          <th style={{ width: 40 }}></th>
                          <th>
                            Vendor Name{" "}
                            <FontAwesomeIcon icon={faSort} className="ms-1" />
                          </th>
                          <th>
                            <FontAwesomeIcon icon={faPaperPlane} className="me-2" />
                            Total Sent
                          </th>
                          <th>
                            <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                            Delivered
                          </th>
                          <th>
                            <FontAwesomeIcon icon={faTimesCircle} className="me-2" />
                            Failed
                          </th>
                          <th>
                            <FontAwesomeIcon icon={faClock} className="me-2" />
                            DLR Await
                          </th>
                          <th>Vendor Cost</th>
                          <th style={{ width: 40 }}></th>
                        </tr>
                      </thead>
                      <tbody>
                        {vendors.map((v) => {
                          const isOpen = !!openRows[v.name];
                          return (
                            <React.Fragment key={v.name}>
                              <tr
                                className="sr-main-row"
                                onClick={() => toggleRow(v.name)}
                              >
                                <td className="text-center">
                                  <FontAwesomeIcon
                                    icon={isOpen ? faChevronDown : faChevronRight}
                                    className="sr-chev"
                                  />
                                </td>
                                <td>
                                  <span className="sr-uname">{v.name}</span>
                                </td>
                                <td className="sr-strong">{fmt(v.t)}</td>
                                <td>
                                  <div className="sr-stat sr-green">
                                    <b>{fmt(v.d)}</b> <span>({pct(v.d, v.t)}%)</span>
                                  </div>
                                </td>
                                <td>
                                  <div className="sr-stat sr-red">
                                    <b>{fmt(v.f)}</b> <span>({pct(v.f, v.t)}%)</span>
                                  </div>
                                </td>
                                <td>
                                  <div className="sr-stat sr-amber">
                                    <b>{fmt(v.o)}</b> <span>({pct(v.o, v.t)}%)</span>
                                  </div>
                                </td>
                                <td className="sr-strong">
                                  {fmtCost(v.vendor)}
                                </td>
                                <td className="text-center">
                                  {isOpen && (
                                    <FontAwesomeIcon icon={faChevronUp} className="sr-chev" />
                                  )}
                                </td>
                              </tr>
                              {isOpen && (
                                <tr>
                                  <td colSpan={8}className="p-0 sr-open-cell">
                                    <div className="sr-break">
                                      <div className="sr-sub-title">
                                        1. Usernames ({v.name})
                                      </div>
                                      <div className="sr-inner-wrap">
                                        <table className="sr-inner">
                                          <thead>
                                            <tr>
                                              <th style={{ width: 36 }}></th>
                                              <th>Username</th>
                                              <th>Total Sent</th>
                                              <th>Delivered</th>
                                              <th>Failed</th>
                                              <th>DLR Await</th>
                                              <th>Vendor Cost</th>
                                              {/* <th style={{ width: 36 }}></th> */}
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {v.userRows.map((u) => {
                                              const key = v.name + "|" + u.user;
                                              const uOpen = openUser === key;
                                              return (
                                                <React.Fragment key={key}>
                                                  <tr
                                                    className={
                                                      "sr-user-row" + (uOpen ? " sr-user-open" : "")
                                                    }
                                                    onClick={() => toggleUser(key)}
                                                  >
                                                    <td className="text-center">
                                                      <FontAwesomeIcon
                                                        icon={uOpen ? faChevronDown : faChevronRight}
                                                        className="sr-chev"
                                                      />
                                                    </td>
                                                    <td className="sr-strong">{u.user}</td>
                                                    <td className="sr-strong">{fmt(u.t)}</td>
                                                    <td className="sr-green">{fmt(u.d)}</td>
                                                    <td className="sr-red">{fmt(u.f)}</td>
                                                    <td className="sr-amber">{fmt(u.o)}</td>
                                                    <td className="sr-strong">{fmtCost(u.vendorCost)}</td>
                                                    {/* <td className="text-center">
                                                      <FontAwesomeIcon
                                                        icon={uOpen ? faChevronUp : faChevronRight}
                                                        className="sr-chev"
                                                      />
                                                    </td> */}
                                                  </tr>
                                                  {uOpen && (
                                                    <tr>
                                                      <td colSpan={8} className="p-2">
                                                        <div className="sr-nest">
                                                          <div className="sr-sub-title">
                                                            2. Country Breakdown ({u.user})
                                                          </div>
                                                          <div className="sr-inner-wrap">
                                                            <table className="sr-inner">
                                                              <thead>
                                                                <tr>
                                                                  <th>Country Code</th>
                                                                  <th>Country</th>
                                                                  <th>Total Sent</th>
                                                                  <th>Delivered</th>
                                                                  <th>Failed</th>
                                                                  <th>DLR Await</th>
                                                                  <th>Vendor Cost</th>
                                                                  <th>Submit Date</th>
                                                                </tr>
                                                              </thead>
                                                              <tbody>
                                                                {u.rows.map((r, j) => (
                                                                  <tr key={j}>
                                                                    <td className="sr-strong">{r.countryCode}</td>
                                                                    <td>{countryNameOf(r.countryCode)}</td>
                                                                    <td className="sr-strong">{fmt(r.t)}</td>
                                                                    <td className="sr-green">
                                                                      {fmt(r.d)} ({pct(r.d, r.t)}%)
                                                                    </td>
                                                                    <td className="sr-red">
                                                                      {fmt(r.f)} ({pct(r.f, r.t)}%)
                                                                    </td>
                                                                    <td className="sr-amber">
                                                                      {fmt(r.o)} ({pct(r.o, r.t)}%)
                                                                    </td>
                                                                    <td className="sr-strong">
                                                                      {fmtCost(r.vendorCost)}
                                                                    </td>
                                                                    <td>{r.date}</td>
                                                                  </tr>
                                                                ))}
                                                              </tbody>
                                                            </table>
                                                          </div>
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  )}
                                                </React.Fragment>
                                              );
                                            })}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          );
                        })}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorReport;
